import { gql } from '@apollo/client'

/* eslint-disable import/prefer-default-export */
export const GET_CONTENT_POLICY_BATCH = gql`
 query GetContentPolicyBatch($contentIds: [Int!]!, $languages: [String!]!) {
    contentList(
        where: {
            contentId: { in: $contentIds }
        }
        language: $languages
    ) {
        content {
            contentId
            contentPolicy {
                optionIds
            }
        }
    }
}
`
